import React from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { copiaCampo } from "../../../../Funcoes";
import stylesGeral from './../index.module.scss';
import { ListaComponent } from '../../../../Componentes/components';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function FormularioEmpresaPrincipalFiliais({
	empresaPrincipal = null,
	filiais = []
}){

	// campos para referencia
	const camposRef = {
		empresaPrincipalCnpj: React.useRef()
	}

	return <>
		{empresaPrincipal && <Card className='border-0 shadow-sm mb-2'>
			<Card.Header className='mb-0 border-0 bg-white'>
				<Card.Title 
					className={[
						'pointer d-flex justify-content-between align-center',
						'p-0 mb-0'
					].join(' ')}
				>
					
					{/* cursor: pointer;
					display: flex;
					justify-content: space-between;
					align-items: center; */}
					Empresa Principal
				</Card.Title>
			</Card.Header>
			<Card.Body className='pt-1'>
				<Row className="m-0 my-2" style={{gap: 10}}>
					<Col className='p-0'>
						<Form.Label>Razão social</Form.Label>
						<Form.Control 
							size="sm"
							disabled
							value={empresaPrincipal.razaoSocial || ''}
						/>
					</Col>
					<Col className='p-0'>
						<Form.Label>CNPJ</Form.Label>
						<InputGroup className="mb-0">
							<Form.Control 
								size="sm"
								disabled
								value={empresaPrincipal.cnpj || ''}
								ref={camposRef.empresaPrincipalCnpj}
							/>
							<InputGroup.Append>
								<Button 
									size="sm"
									className={[stylesGeral.btnFormularios, ''].join(' ')}
									variant="outline-secondary"
									onClick={() => {
		
										// pega o campo
										let campo = camposRef.empresaPrincipalCnpj.current
										copiaCampo(campo);
		
									}}
								>
									<FontAwesomeIcon style={{fontSize: 14}} className="icone" icon={["fas", "copy"]}/>
								</Button>
							</InputGroup.Append>
						</InputGroup>
					</Col>
				</Row>
			</Card.Body>
		</Card>}
	
		{(filiais && !!filiais.length) && <Card className='border-0 shadow-sm mb-2'>
			<Card.Header className='mb-0 border-0 bg-white'>
				<Card.Title 
					className={[
						'pointer d-flex justify-content-between align-center',
						'p-0 mb-0'
					].join(' ')}
				>
					Filiais da empresa
				</Card.Title>
			</Card.Header>
			<Card.Body className='pt-1'>
				<ListaComponent>
					<table className="table table-hover tabela m-0">
						<thead>
							<tr>
								<th>Razão social</th>
								<th>CNPJ</th>
							</tr>
						</thead>
						<tbody>
							{filiais.map((filial) => {
								return <tr
									key={"filial" + filial.id}
									style={{cursor: 'pointer'}}
									className={['registro'].join(' ')}
								>
									<td>
										{filial.razaoSocial}
									</td>
									<td className='estreito text-center'>
										{filial.cnpj}
									</td>
								</tr>
							})}
						</tbody>
					</table>
				</ListaComponent>
			</Card.Body>
		</Card>}
	</>
}